export interface NavItem {
  key: string;
  label: string;
  path: string;
}

export const navItems: NavItem[] = [
  { key: "home", label: "首页", path: "/" },
  { key: "episodes", label: "剧集列表", path: "/episodes" },
  { key: "plot", label: "剧情介绍", path: "/plot" },
  { key: "related", label: "相关推荐", path: "/related" },
  { key: "about", label: "关于", path: "/about" },
];

export const siteInfo = {
  brand: "无颜之月",
  tagline: "在线观看",
  email: "contact@wuyanzhiyue.example.com",
  icp: "演示站点 · 内容均为虚构",
};